import React, { useMemo } from 'react';

import { ActiveElementsContext } from './ActiveElementsContext';
import { ActiveElementsStore } from './ActiveElementsStore';

export const ActiveElementsProvider = ({ children, store }) => {
	const value = useMemo(() => store ?? new ActiveElementsStore(), [store]);
	return <ActiveElementsContext.Provider value={value}>{children}</ActiveElementsContext.Provider>;
};
